// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"549d8434","453":"eb617abd","796":"fb0ebb58"}[chunkId] + ".chunk.js";
};